import { motion, AnimatePresence, useIsPresent} from 'framer-motion';
import React, { useEffect, useState, useRef } from 'react';

function SearchIcon(){
  return(    
          <svg className="fill-black dark:fill-white" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_297_4740" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x={0} y={0} width={24} height={25}>
              <rect y="0.757812" width={24} height={24} fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_297_4740)">
              <path d="M19.6 21.7578L13.3 15.4578C12.8 15.8578 12.225 16.1745 11.575 16.4078C10.925 16.6411 10.2333 16.7578 9.5 16.7578C7.68333 16.7578 6.14583 16.1286 4.8875 14.8703C3.62917 13.612 3 12.0745 3 10.2578C3 8.44115 3.62917 6.90365 4.8875 5.64531C6.14583 4.38698 7.68333 3.75781 9.5 3.75781C11.3167 3.75781 12.8542 4.38698 14.1125 5.64531C15.3708 6.90365 16 8.44115 16 10.2578C16 10.9911 15.8833 11.6828 15.65 12.3328C15.4167 12.9828 15.1 13.5578 14.7 14.0578L21 20.3578L19.6 21.7578ZM9.5 14.7578C10.75 14.7578 11.8125 14.3203 12.6875 13.4453C13.5625 12.5703 14 11.5078 14 10.2578C14 9.00781 13.5625 7.94531 12.6875 7.07031C11.8125 6.19531 10.75 5.75781 9.5 5.75781C8.25 5.75781 7.1875 6.19531 6.3125 7.07031C5.4375 7.94531 5 9.00781 5 10.2578C5 11.5078 5.4375 12.5703 6.3125 13.4453C7.1875 14.3203 8.25 14.7578 9.5 14.7578Z"  />
            </g>
          </svg>
  )
}

function SubscribeButton(){
  return(    
    <button type="button" className="z_btn z_btn_primary">
      <span>{window.is_member ? 'Account' : 'Subscribe'}</span>
      <svg className="size-6 ml-1" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_298_3874" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x={0} y={0} width={24} height={25}>
          <rect y="0.5" width={24} height={24} fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_298_3874)">
          <path d="M11 13.5H5V11.5H11V5.5H13V11.5H19V13.5H13V19.5H11V13.5Z" fill="white" />
        </g>
      </svg>
    </button>
  )
}

function MobileNav(){
    const [isOpen, setIsOpen] = useState(false);
    const [navItems, setNavItems] = useState([]);

    useEffect(()=>{
        const handleOpenMenu = (event) => {
            console.log('[+] Handle open Mobile menu run...'); 
            let action = event.detail.action;
            handleOpen(action);
        };
        const main_navigation = document.getElementById('main_navigation');
        const li_items = main_navigation.querySelectorAll('li');
        
        let nav_items = [];
        for(let item of li_items){
            const a_href = item.querySelector('a').href;
            const a_title = item.querySelector('a').innerText;
            const is_current = item.classList.contains('nav-current');
            nav_items.push({title:a_title, href:a_href, active:is_current});
        }
        setNavItems(nav_items);
        window.addEventListener('openNoiseMobileMenu', handleOpenMenu);

        return () => {
            window.removeEventListener('openNoiseMobileMenu', handleOpenMenu);
        };
    }, []);

    // Variants for menu container animation
    const containerVariants = {
        hidden: { opacity: 0, y:10 },
        visible: { 
          y:0,
          opacity: 1, 
          transition: { 
            duration: 0.3
          }
        },
        exit: { opacity: 0, transition: { duration: 0.3, delay:0.3 }}
      };

    const handleOpen = (action) =>{
      if(action){
        document.getElementsByTagName('body')[0].style.overflow = 'hidden';
        setIsOpen(true);
      }
    }

     const handleClose = () => {
        setIsOpen(false);
        document.getElementsByTagName('body')[0].style.overflow = '';
     }

     //let nav_items = [...navItems, {title:'Subscribe', href:'#', active:false}];

  return (
    <>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="fixed flex-col top-0 left-0 w-full h-screen bg-white dark:bg-black z-[9999] flex items-end"
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={containerVariants}
          >
            <motion.ul 
            className="list-none flex flex-col gap-y-3 text-[2.4rem] tracking-wide font-title font-bold ml-0 pt-32 pr-4 text-right"
            >           
              {navItems.map((el, index) => {
                return(
                <motion.li 
                key={index} 
                initial={{opacity:0, y:-100, transition:{y:{stiffness: 1000}}}}
                animate={{opacity:1, y:0}}
                exit={{opacity:0, y:-100, delay:0.1*index, transition:{y:{stiffness: 1000}}}}
                transition={{duration:0.2, delay:0.1*index, y:{ stiffness: 1000, velocity: 50}}}      
                className={`text-black dark:text-white ${el.active ? 'nav-current' : ''}`}          
                >
                  <a href={el.href}>{el.title}</a>
                </motion.li>
              )})}
            </motion.ul>

            <motion.ul initial={{opacity:0}} animate={{opacity:1}} exit={{opacity:0}}
            className='mt-3 ml-0 list-none w-full flex flex-col justify-end gap-6'>
              <motion.li className='text-lg flex justify-end pr-4 text-black dark:text-white'>
                <a href='/#/search'>
                  <div className="size-8">
                  <SearchIcon/>
                  </div>
                </a>
              </motion.li>
              <motion.li className='text-lg mt-8 flex justify-end pr-4 text-black dark:text-white'>
                <a href='/#/portal/signup'>
                <SubscribeButton/>
                </a>
              </motion.li>
            </motion.ul>

            <div onClick={handleClose} className="flex justify-end absolute top-0 left-0 w-full pt-7 pr-3">
                <div className="hamburger hamburger--squeeze is-active">
                    <div className="hamburger-box">
                    <div className="hamburger-inner"></div>
                    </div>
                </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}

export default MobileNav;